/** @format */
import React from "react";
import { Chip, Tooltip, Typography, IconButton } from "@mui/material";
import { lighten } from "polished";
import Swal from "sweetalert2";
import date from "date-and-time";
import b from "../../assets/images/b.png";
import NoteIcon from "@mui/icons-material/Note";
const hasSameMonthAsPreviousRow = (params) => {
  const previousRowNode = params.api.getDisplayedRowAtIndex(
    params.rowIndex - 1
  );
  if (!previousRowNode) return true;
  const currentMonth = params.data.loadTime.split("-")[1];
  const previousMonth = previousRowNode.data.loadTime.split("-")[1];
  return currentMonth === previousMonth;
};

const createColumnDefs = (handlePdfClick, handleNoteClick) => {
  return [
    // {
    //   headerName: "",
    //   field: "",
    //   maxWidth: 50,
    //   minWidth: 50,
    //   checkboxSelection: true,

    //   filter: false,
    //   suppressMenu: true,
    // },
    {
      field: "note",
      headerName: "Not",
      maxWidth: 80,
      filter: false,
      suppressMenu: true, // Üç nokta menüsünü kaldırır
      cellRenderer: (params) => (
        <IconButton
          onClick={() => handleNoteClick(params.data.note, params.data.id)}
        >
          <NoteIcon />
        </IconButton>
      ),
    },
    {
      field: "loadTime",
      suppressMenu: true,
      maxWidth: 200,
      minWidth: 80,
      headerName: "Yükleme Zamanı",
      cellRenderer: (props) => (
        <Tooltip title="İnternet vergi dairesine yüklenme zamanı">
          <Typography
            sx={{
              fontSize: "14px",
            }}
          >
            {date.format(new Date(props.data.loadTime), "DD-MM-YYYY HH:mm:ss")}
          </Typography>
        </Tooltip>
      ),
      cellStyle: (props) => {
        return {
          textAlign: "start",
          alignItems: "center",
          display: "flex",
          overflow: "hidden",
          // Kontrol fonksiyonunu kullanarak sınıf ekleyin
          borderTop: hasSameMonthAsPreviousRow(props)
            ? ""
            : "2px solid #1976d2",
        };
      },
    },
    {
      minWidth: 100,
      maxWidth: 200,
      field: "taxationPeriod",
      suppressMenu: true,
      headerName: "Dönem",
      cellStyle: (props) => {
        return {
          textAlign: "start",
          alignItems: "center",
          display: "flex",
          overflow: "hidden",
          // Kontrol fonksiyonunu kullanarak sınıf ekleyin
          borderTop: hasSameMonthAsPreviousRow(props)
            ? ""
            : "2px solid #1976d2",
        };
      },
    },

    {
      maxWidth: 200,
      minWidth: 100,
      field: "declarationType",
      flex: 0.7,
      suppressMenu: true,
      headerName: "Tür",
      cellStyle: (props) => {
        return {
          textAlign: "start",
          alignItems: "center",
          display: "flex",
          overflow: "hidden",
          // Kontrol fonksiyonunu kullanarak sınıf ekleyin
          borderTop: hasSameMonthAsPreviousRow(props)
            ? ""
            : "2px solid #1976d2",
        };
      },
      cellRenderer: (props) => (
        <Chip
          size="small"
          sx={{
            backgroundColor:
              props?.data?.declarationType === "MUHSGK"
                ? lighten(0.4, "#0d6efd")
                : "",
            color: props?.data?.declarationType === "MUHSGK" ? "#0d6efd" : "",
          }}
          label={props?.data?.declarationType}
        />
      ),
    },
    {
      maxWidth: 130,
      field: "tahakkuklar",
      suppressMenu: true,
      headerName: "Beyanname",
      checkboxSelection: false,
      filter: false,

      cellRenderer: (props) => (
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            overflow: "hidden",
            gap: 5,
            alignItems: "center",
            position: "relative", // Eklendi
          }}
        >
          <Tooltip
            title={
              props?.data?.rDriveDeclarationID
                ? "Beyannameyi görmek ve not eklemek için tıklayın"
                : ""
            }
          >
            <span>
              <img
                src={b}
                style={{
                  display: props?.data?.rDriveDeclarationID ? "block" : "none",
                  cursor: props?.data?.rDriveDeclarationID ? "pointer" : "",
                  height: "22px",
                }}
                onClick={() =>
                  handlePdfClick(
                    props?.data?.rDriveDeclarationID,
                    props?.data?.note,
                    props?.data?.id
                  )
                }
              />
              <Typography
                sx={{
                  fontSize: "11px",
                  display:
                    !props?.data?.rDriveDeclarationID &&
                    (props.data.declarationType === "GELIR" ||
                      props.data.declarationType === "GGECICI" ||
                      props.data.declarationType === "KGECICI" ||
                      props.data.declarationType === "KURUMLAR")
                      ? "block"
                      : "none",
                }}
                onClick={() =>
                  Swal.fire({
                    text: "Beyanname yok",
                    icon: "warning",
                    confirmButtonText: "Tamam",
                    customClass: {
                      htmlContainer: ".swal2-container",
                    },
                  })
                }
              >
                {props?.data?.status === "Onaylandı" ||
                props?.data?.status === "Onay Bekliyor"
                  ? "Beyanname sisteme yükleniyor..."
                  : "Beyanname yok"}
              </Typography>
            </span>
          </Tooltip>{" "}
        </div>
      ),
      cellStyle: (props) => {
        return {
          textAlign: "start",
          alignItems: "center",
          display: "flex",
          overflow: "hidden",
          // Kontrol fonksiyonunu kullanarak sınıf ekleyin
          borderTop: hasSameMonthAsPreviousRow(props)
            ? ""
            : "2px solid #1976d2",
        };
      },
    },

    {
      maxWidth: 150,
      minWidth: 100,
      field: "taxAdministration",
      filter: false,
      hide: true,
      suppressMenu: true,
      headerName: "Vergi Dairesi",
      valueGetter: function (params) {
        return (
          params.data.taxAdministration +
          (params.data.branchNumber ? ` / ${params.data.branchNumber}` : "")
        );
      },
      cellStyle: (props) => {
        return {
          textAlign: "start",
          alignItems: "center",
          display: "flex",
          overflow: "hidden",
          // Kontrol fonksiyonunu kullanarak sınıf ekleyin
          borderTop: hasSameMonthAsPreviousRow(props)
            ? ""
            : "2px solid #1976d2",
        };
      },
    },

    {
      width: "10%",
      maxWidth: 150,
      field: "status",
      suppressMenu: true,
      headerName: "Durum",
      cellRenderer: (props) => (
        <Chip
          size="small"
          sx={{
            width: "100%",
            borderRadius: "4px",
            backgroundColor:
              props?.data?.status === "Onaylandı"
                ? lighten(0.4, "#5cb85c")
                : props?.data?.status === "İptal"
                ? lighten(0.3, "#d9534f")
                : props?.data?.status === "Hatalı"
                ? lighten(0.1, "#d9534f")
                : lighten(0.3, "#f0ad4e"),
            color:
              props?.data?.status === "Onaylandı"
                ? "#5cb85c"
                : props?.data?.status === "İptal"
                ? "#d9534f"
                : props?.data?.status === "Hatalı"
                ? lighten(0.4, "#d9534f")
                : "#f0ad4e",
          }}
          label={props?.data?.status}
        />
      ),
      cellStyle: (props) => {
        return {
          borderTop: hasSameMonthAsPreviousRow(props)
            ? ""
            : "2px solid #1976d2",
        };
      },
    },

    {
      minWidth: 100,
      maxWidth: 700,
      field: "note",
      suppressMenu: true,
      headerName: "Açıklama",
      cellStyle: (props) => {
        return {
          textAlign: "start",
          alignItems: "center",
          display: "flex",
          overflow: "hidden",
          // Kontrol fonksiyonunu kullanarak sınıf ekleyin
          borderTop: hasSameMonthAsPreviousRow(props)
            ? ""
            : "2px solid #1976d2",
        };
      },
    },
  ];
};

export default createColumnDefs;
